import { useState } from "react"
import { createContext } from "react"
import { Api } from "../componentes/Api"


export const UserContext = createContext()

const UserProvider = ({children}) => {
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))


    const iniciarSession = (data) => {
        window.localStorage.setItem("sesion_usuario", JSON.stringify(data))
       // window.localStorage.setItem("sesion_usuario", JSON.stringify(data))

        let response = fetch(Api + `administracion/ListaEmpresas/${data.idUsuario}`).then((response) => {
            return response.ok ? response.json() : Promise.reject(response);
        })
            .then((dataJson) => {
                var data1 = dataJson[0];
                window.localStorage.setItem("Empresa", data1.descripcion)
            })
          
        setUser(JSON.stringify(data))
    }

    const cerrarSession = () => {
        window.localStorage.removeItem("sesion_usuario")
        window.localStorage.removeItem("Empresa")
        
        setUser(null)
    }

    return (
        <UserContext.Provider value={{ user, iniciarSession, cerrarSession}}>
            {children}
        </UserContext.Provider>
        )
}

export default UserProvider